import { useSelector } from 'react-redux'
import {
  StyledSubArrowImg,
  StyledSubForwardBtn,
  StyledSubPrevButton,
  StyledSwiperContainer,
} from './styles'
import { RootState } from 'store/store'
import { CSSProperties, ReactNode, useState } from 'react'
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'
import { Swiper as SwiperType } from 'swiper'
import { Navigation } from 'swiper/modules'
import forwardbtn from 'assets/images/forwardbtn.png'
import backBtn from 'assets/images/backBtn.png'
import 'swiper/css'

type SubscriptionsProps = {
  slides: ReactNode[] | JSX.Element[]
  slidesKey: string
  slidesStyle?: CSSProperties
} & SwiperProps

export const PersonalAreaSwiper = ({
  slides,
  slidesKey,
  slidesStyle = {},
  ...props
}: SubscriptionsProps) => {
  const [isAtBeginning, setIsAtBeginning] = useState(true)
  const [isAtEnd, setIsAtEnd] = useState(false)
  const direction = useSelector(
    (state: RootState) => state.layout.language.direction,
  )
  const isRTL = direction === 'rtl'

  return (
    <StyledSwiperContainer>
      <Swiper
        className={`${isRTL ? 'swiper-rtl' : 'swiper-ltr'}`}
        key={isRTL ? 'rtl' : 'ltr'}
        style={{
          width: '100%',
          position: 'relative',
          marginInlineStart: 0,
          overflow: 'visible',
        }}
        spaceBetween={18}
        slidesPerView={'auto'}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        modules={[Navigation]}
        onSlideChange={(swiper: SwiperType) => {
          setIsAtBeginning(swiper.isBeginning)
          setIsAtEnd(swiper.isEnd)
        }}
        onReachEnd={() => setIsAtEnd(true)}
        onReachBeginning={() => setIsAtBeginning(true)}
        {...props}
      >
        {slides.map((slide: ReactNode | JSX.Element, index: number) => (
          <SwiperSlide style={slidesStyle} key={`${slidesKey}-${index}`}>
            {slide}
          </SwiperSlide>
        ))}
        {isRTL ? (
          <>
            <StyledSubPrevButton
              className="swiper-button-prev"
              isHidden={isAtBeginning}
            >
              <StyledSubArrowImg src={backBtn} alt="Previous" />
            </StyledSubPrevButton>

            <StyledSubForwardBtn
              className="swiper-button-next"
              isHidden={isAtEnd}
            >
              <StyledSubArrowImg src={forwardbtn} alt="Next" />
            </StyledSubForwardBtn>
          </>
        ) : (
          <>
            <StyledSubForwardBtn
              className="swiper-button-next"
              isHidden={isAtEnd}
            >
              <StyledSubArrowImg src={forwardbtn} alt="Next" />
            </StyledSubForwardBtn>
            <StyledSubPrevButton
              className="swiper-button-prev"
              isHidden={isAtBeginning}
            >
              <StyledSubArrowImg src={backBtn} alt="Previous" />
            </StyledSubPrevButton>
          </>
        )}
      </Swiper>
    </StyledSwiperContainer>
  )
}
